import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import config from '@/config'

import LoginView from '@/views/login/view'
import PortalView from '@/views/portal/view'

Vue.use(VueRouter)

export const PageNames = {
  Home: 'Home',
  UserLogin: 'UserLogin',
  Guide: 'Guide',
  DataCenter: 'DataCenter'
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: PageNames.Home,
    component: PortalView
  },
  {
    path: '/login',
    name: PageNames.UserLogin,
    component: LoginView
  },
  {
    path: '/guide',
    name: PageNames.Guide,
    component: () => import(/* webpackChunkName: "tech-guide" */ '@/views/guide/view')
  },
  {
    path: '/data-center',
    name: PageNames.DataCenter,
    component: () => import(/* webpackChunkName: "data-center" */ '@/views/data-center/view')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: config.publicPath,
  routes
})

export default router
